import AddCard from '../modal/AddCard' 


const defaultColumnProperties = {
  sortable: true
};


 export const columns = [
    
  {
    key: 'year',
    name: 'Year',
    width: 40,
    resizable: false,
    sortable: true,
    filterable:true,
    editable: false,
    sortDescendingFirst: true,
    formatter(props) {
      return <>{props.row.year}</>;
    },
  },
  {
    key: 'setName',
    name: 'Set Name',
    editable: false,
    width: 150,
    resizable: false,
  },
  {
    key: 'player',
    name: 'Player',
    editable: false,
    width: 160,
    resizable: false,
    },
  {
    key: 'cardNum',
    name: 'Number',
    editable: false,
    width: 60,
    resizable: false,
  },
  {
    key: 'condition',
    name: 'Grade',
    editable: false,
    width: 50,
    resizable: false,
    formatter(props) {
      return <>{isNaN(props.row.condition) || parseInt(props.row.condition) < 0 || parseInt(props.row.condition) >= 10 ? '' : props.row.condition}</>;
    },
  },
  {
    key: 'graded',
    name: 'Graded',
    editable: false,
    width: 90,
    resizable: false,
  },
  {
    key: 'qualifier',
    name: 'Qualifier',
    editable: false,
    // width: 60,
    resizable: false,
  },
  {
    key: 'gameUsed',
    name: 'GU',
    editable: false,
    width: 35,
    resizable: false,
    formatter(props) {
      return <>{props.row.gameUsed ? 'Yes' : 'No'}</>;
    },
  },
  {
    key: 'autograph',
    name: 'AU',
    editable: false,
    width: 35,
    resizable: false,
    formatter(props) {
      return <>{props.row.autograph ? 'Yes' : 'No'}</>;
    },
  },
  // {
  //   key: 'serialNumber',
  //   name: 'Serial Number',
  //   editable: false,
  //   width: 80,
  //   resizable: false,
  // },
  {
    key: 'price',
    name: 'Price',
    editable: false,
    // width: 80,
    resizable: false,
    sortable: true,
    sortDescendingFirst: true,
  },
  {
    key: 'edit',
    name: 'edit',
    // width: 50,
    formatter(props) {
      return (
        <AddCard mode="edit" card={props.row} />
      )
  }
}
].map(c => ({ ...c, ...defaultColumnProperties }))